module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/more-f5c71f38a9d538b34eee59a6c3248d2e.svg";